// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Deliveries_componentWrapper__sGyMe","carrierCell":"Deliveries_carrierCell__4mTbm","filtersWrapper":"Deliveries_filtersWrapper__4-Q3L"};